import i18n from '../../../../../../translations/strings';

export const fieldNameResumeRow = [
  i18n.t('booking.dateResume'),
  i18n.t('booking.timeResume'),
  i18n.t('booking.room'),
  i18n.t('booking.inPresenceResume'),
  i18n.t('booking.onlineResume'),
  i18n.t('booking.extraServicesResume'),
];

export const MAX_ROW_TO_SHOW = 3;
